const LOAD_DATA_MASTER_CITY         = 'LOAD_DATA_MASTER_CITY'
const LOAD_DATA_MASTER_CITY_SUCCESS = 'LOAD_DATA_MASTER_CITY_SUCCESS'
const LOAD_DATA_MASTER_CITY_FAILED  = 'LOAD_DATA_MASTER_CITY_FAILED'
const UNMOUNT_DATA_MASTER_CITY      = 'UNMOUNT_DATA_MASTER_CITY'

const initialState = {
  loading: true,
  data: null,
  message: null,
  meta: null
}

const cityReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_DATA_MASTER_CITY:
      return {
        ...state,
        loading: true,
        data: null,
        meta: null
      }
    case LOAD_DATA_MASTER_CITY_SUCCESS:
      return {
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
        meta: action.payload.meta
      }
    case LOAD_DATA_MASTER_CITY_FAILED:
      return {
        ...state, 
        loading: false,
        data: null,
        message: 'FAILED',
        meta: null
      }
    case UNMOUNT_DATA_MASTER_CITY:
      return { 
        ...state, 
        loading: true,
        data: null,
        meta: null
      }
    default:
      return state
  }
}
export default cityReducer